//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Return event log study by id.
 * @param studyId Study Id
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 */
export function getEventLog(studyId: number, patientUniqId?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/export/eventlog/{studyId}?";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
    if (patientUniqId !== undefined && patientUniqId !== null)
        url_ += "patientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetEventLog,
        ...config,
        responseType: "blob",
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/octet-stream"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetEventLog(_response);
    });
}

function processGetEventLog(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}

/**
 * Returns all answers for the selected forms and surveys
 * @param studyId Study id
 * @param surveyTypes (optional) Array of survey types to export
 * @param formTypes (optional) Array of form types to export
 * @param lifecycleStates (optional) If not null, only those forms will be exported whose lifecycle state is contained here.
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 * @param lastFormResultVersionOnly (optional) Get only the last form result version (optional)
 * @param formResultId (optional) 
 */
export function getStatistics(studyId: number, surveyTypes?: string[] | undefined, formTypes?: string[] | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, patientUniqId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, formResultId?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/export/statistics/{studyId}?";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
    if (surveyTypes === null)
        throw new Error("The parameter 'surveyTypes' cannot be null.");
    else if (surveyTypes !== undefined)
        surveyTypes && surveyTypes.forEach(item => { url_ += "surveyTypes=" + encodeURIComponent("" + item) + "&"; });
    if (formTypes === null)
        throw new Error("The parameter 'formTypes' cannot be null.");
    else if (formTypes !== undefined)
        formTypes && formTypes.forEach(item => { url_ += "formTypes=" + encodeURIComponent("" + item) + "&"; });
    if (lifecycleStates !== undefined && lifecycleStates !== null)
        lifecycleStates && lifecycleStates.forEach(item => { url_ += "lifecycleStates=" + encodeURIComponent("" + item) + "&"; });
    if (patientUniqId !== undefined && patientUniqId !== null)
        url_ += "patientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
    if (lastFormResultVersionOnly !== undefined && lastFormResultVersionOnly !== null)
        url_ += "lastFormResultVersionOnly=" + encodeURIComponent("" + lastFormResultVersionOnly) + "&";
    if (formResultId !== undefined && formResultId !== null)
        url_ += "formResultId=" + encodeURIComponent("" + formResultId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStatistics,
        ...config,
        responseType: "blob",
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/octet-stream"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStatistics(_response);
    });
}

function processGetStatistics(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}

/**
 * Returns the types of forms and surveys that can be exported
 * @param studyId Study id
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 * @param withMissedSurveyTypes (optional) 
 */
export function getStatisticTypesToExport(studyId: number, patientUniqId?: string | null | undefined, withMissedSurveyTypes?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.StatisticTypesDto> {
    let url_ = getBaseUrl() + "/api/export/statistics/typesToExport/{studyId}?";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
    if (patientUniqId !== undefined && patientUniqId !== null)
        url_ += "patientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
    if (withMissedSurveyTypes !== undefined && withMissedSurveyTypes !== null)
        url_ += "withMissedSurveyTypes=" + encodeURIComponent("" + withMissedSurveyTypes) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStatisticTypesToExport,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStatisticTypesToExport(_response);
    });
}

function processGetStatisticTypesToExport(response: AxiosResponse): Promise<Types.StatisticTypesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StatisticTypesDto.fromJS(resultData200);
        return Promise.resolve<Types.StatisticTypesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StatisticTypesDto>(null as any);
}
let _requestConfigGetEventLog: Partial<AxiosRequestConfig> | null;
export function getGetEventLogRequestConfig() {
  return _requestConfigGetEventLog;
}
export function setGetEventLogRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetEventLog = value;
}
export function patchGetEventLogRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetEventLog = patch(_requestConfigGetEventLog ?? {});
}

let _requestConfigGetStatistics: Partial<AxiosRequestConfig> | null;
export function getGetStatisticsRequestConfig() {
  return _requestConfigGetStatistics;
}
export function setGetStatisticsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStatistics = value;
}
export function patchGetStatisticsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStatistics = patch(_requestConfigGetStatistics ?? {});
}

let _requestConfigGetStatisticTypesToExport: Partial<AxiosRequestConfig> | null;
export function getGetStatisticTypesToExportRequestConfig() {
  return _requestConfigGetStatisticTypesToExport;
}
export function setGetStatisticTypesToExportRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStatisticTypesToExport = value;
}
export function patchGetStatisticTypesToExportRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStatisticTypesToExport = patch(_requestConfigGetStatisticTypesToExport ?? {});
}